import { URL_CONFIG } from "./urlConfig";

export const ATP_API_URL = {
  LOGIN: `${URL_CONFIG.ATP_API_BASE_URL}api/Auth/login`,
  REQUEST_OTP: `${URL_CONFIG.ATP_API_BASE_URL}api/Auth/login`,
  VERIFY_OTP: `${URL_CONFIG.ATP_API_BASE_URL}api/Auth/verify-otp`,
  PRIMARY_CREATE_DATA: `${URL_CONFIG.ATP_API_BASE_URL}api/Onboarding/primary-create-onboarding`, // TODO: changed api end point

  TOTAL_COUNTS: `${URL_CONFIG.ATP_API_BASE_URL}api/Onboarding/total-counts`,
  PARENT_LIST: `${URL_CONFIG.ATP_API_BASE_URL}api/Onboarding/parent-list`,

  UPLOAD_DOCUMENTS: `${URL_CONFIG.ATP_API_BASE_URL}api/Onboarding/upload-document`,

  KYC_FORM_FIELDS_DATA: `${URL_CONFIG.ATP_API_BASE_URL}api/Onboarding/insert-kyc`,
  GET_ALL_DATA_SEARCH: `${URL_CONFIG.ATP_API_BASE_URL}api/Onboarding/get-entities`,

  // APPROVE_ENTITY: `${URL_CONFIG.ATP_API_BASE_URL}api/entity/onboarding-approved`,
  APPROVE_ENTITY_NEW: `${URL_CONFIG.ATP_API_BASE_URL}api/Onboarding/approve-entity`,
  VIEW_DOCUMENT: `${URL_CONFIG.ATP_API_BASE_URL}api/Onboarding/view-document`,
  // DEFICIENCY_ENTITY: `${URL_CONFIG.ATP_API_BASE_URL}api/entity/onboarding-deficiency`,
  DEFICIENCY_ENTITY_NEW: `${URL_CONFIG.ATP_API_BASE_URL}api/Onboarding/deficiency-entity`,

  COMPANY_CHILD_DATA: `${URL_CONFIG.ATP_API_BASE_URL}api/Onboarding/entity-parent-child`,

  UPDATE_FORM_ALL_DATA: `${URL_CONFIG.ATP_API_BASE_URL}api/Onboarding/update-entity`, // upadte all data to form in all list pagfe
  ENTITY_KYC_STATUS: `${URL_CONFIG.ATP_API_BASE_URL}api/Onboarding/entity-kyc-status`,

  // TODO: Old apis
  // REQUIRED_DOCUMENTS: `${URL_CONFIG.ATP_API_BASE_URL}api/entity/required-documents`,
  // UPLOAD_DOCUMENT: `${URL_CONFIG.ATP_API_BASE_URL}api/entity/upload-document`,
  // DEPARTMENT_LIST: `${URL_CONFIG.ATP_API_BASE_URL}api/entity/department-list`,
  // UPDATE_ALL_DATA: `${URL_CONFIG.ATP_API_BASE_URL}api/entity/update-onboarding`,
  // GET_ALL_DATA: `${URL_CONFIG.ATP_API_BASE_URL}api/entity/onboardingList`,
  // // TODO: searching the data and all listing data here with paginations
  // GET_ALL_DATA_SEARCH: `${URL_CONFIG.ATP_API_BASE_URL}api/entity/search-onboarding`,
};
